<template>
	<div>
		<div class='knd-map'>		
			<div 
				class="knd-map__map" 
				ref="gewichtmap"
				>
			</div>
		</div>
	</div>
</template>

<script>
	import 'ol/ol.css';
	import Map from 'ol/Map';
	import View from 'ol/View';
	import TileLayer from 'ol/layer/Tile';
	import OSM from 'ol/source/OSM';
	import VectorLayer from 'ol/layer/Vector';
	import VectorSource from 'ol/source/Vector';
	import XYZ from 'ol/source/XYZ';
	import {fromLonLat} from 'ol/proj';
	import * as interaction from 'ol/interaction';
	import {defaults} from 'ol/interaction';
	import olms from 'ol-mapbox-style';
	import Style from 'ol/style/Style';
	import Feature from 'ol/Feature';
	import Point from 'ol/geom/Point';
	import Icon from 'ol/style/Icon';
	import Polygon from 'ol/geom/Polygon';
	import MultiPolygon from 'ol/geom/MultiPolygon';
	import Fill from 'ol/style/Fill';
	import Stroke from 'ol/style/Stroke';
	import {getVectorContext} from 'ol/render';
	import Observable from 'ol/Observable';
	import TopoJSON from 'ol/format/TopoJSON';

	import {schemeBlues} from 'd3-scale-chromatic';
	import {scaleLinear} from 'd3-scale';

	const d3 = {
		schemeBlues,
		scaleLinear
	}

	export default {
		name: 'Map',
		props: ['userLoc', 'step'],
		data() {
			return {
				"map": null,
				"view": null,
				// "key": 'pk.eyJ1IjoiZWxzZW5nZWwiLCJhIjoiY2t2amM3d3dkMnV3MDMxcGdrY3hyOTVpYSJ9.NSHvDGr3IzfeR8DrEhkoVg',
				"key": 'pk.eyJ1Ijoid2V5b25jZSIsImEiOiJja3V4c3JrZHgyOXJuMm5sbnBmeDdrZG1pIn0.xEdkptASss8kKDk1DjgxUw',
				// "style_url": 'https://api.mapbox.com/styles/v1/elsengel/ckvjftmpd3din14ry0e3nxndj',
				"style_url": 'https://api.mapbox.com/styles/v1/weyonce/ckuxtguqy1qhc18my6ekpdcs6',
				"mapData": this.$store.state.mapData,
				"dotLayer": null,
				"buurtLayer": null,
				"gemeenteLayer": null,
			}
		},
		computed: {
			buurtSelected() {
				return this.$store.getters.buurtSelected;
			},

			gemeenteSelected() {
				return this.$store.getters.gemeenteSelected;
			},

			gemeenteAlle() {
				return this.$store.getters.gemeenteAlle;
			},

			userLocation() {
				return this.$store.getters.userLocation;
			}

		},
		mounted() {
			this.initMap();
		},
		watch: {
			step: function (newVal, oldVal) { // watch it
				switch(newVal) {
					case 0:
						this.mapToLoc(this.selectedBuurtExtent);
						break;
					case 1: 
						this.highlightGemeente(this.gemeenteSelected);
						break;
					case 2:
						this.mapToLoc(this.CountryExtent);
				}
			},

			gemeenteSelected: {
				handler() {
					this.drawBuurten();
					// this.highlightGemeente(this.gemeenteSelected);
				},
				deep: true
			},

			buurtSelected: {
				handler() {
					this.getSelectedBuurtExtent();
					// this.mapToBuurt(this.buurtSelected);
					this.mapToLoc(this.selectedBuurtExtent);
				},
				deep: true
			}
		},
		methods: {
			initMap() {
				this.view = new View({
					center: fromLonLat(this.userLocation),
					zoom: 17
				});

				this.map = new Map({
					controls: [],
					target: this.$refs.gewichtmap,
					view: this.view,
					interactions: interaction.defaults({mouseWheelZoom:false, dragPan: false})
				});

				olms(this.map, this.style_url + '?access_token=' + this.key);

				this.drawGemeenten();
			},

			drawGemeenten() {
				let vectorSource = new VectorSource({
					features: (new TopoJSON({layers:'gemeenten2019_zz'})).readFeatures(this.$store.state.gemeenteAlle, {featureProjection: 'EPSG:3857', dataProjection:'EPSG:4326'})
				});

				this.gemeenteLayer = new VectorLayer({
					source: vectorSource
				});

				this.CountryExtent = [373852.9570170686, 6577429.029459489, 804549.2601535877, 7086260.370481656];
				// this.CountryExtents = vectorSource.getExtent();

				// debugger;
				this.map.addLayer(this.gemeenteLayer);
			},

			getStyle(feature) {
				let style = new Style({
					fill: new Fill({
						color: 'yellow',
					})
				});

				return style;
			},			

			styleFunction(feature) {
				let colors = d3.scaleLinear()
					.domain([0, 100])
					.range(["white", "#FF6D61"])
					.unknown("#ccc");

				let percentage = feature.get('buurt_overgewicht_mediaan');
				let colorChoro = colors(percentage);
				let strokeColor = 'white';

				let isSelected = feature.get('buurt_code') === this.buurtSelected.buurt_code;
				if(this.step === 0) {

					colorChoro = isSelected ? colorChoro : 'transparent';
				}
				strokeColor = isSelected ? '#FFF' : 'transparent';

				let stroke = new Stroke({ color: strokeColor, width: 2 });
				let fill = new Fill({ color: colorChoro});
				let style = new Style({ stroke: stroke, fill: fill });
				
				return style;
			},

			getSelectedBuurtExtent() {
				let selectedBuurtCode = this.buurtSelected.buurt_code;

				const features = this.buurtLayer.getProperties().source.getFeatures();

				this.selectedBuurtCode = features.find((buurt) => {
					return selectedBuurtCode === buurt.get('buurt_code');
				});

				var featureGeometry = this.selectedBuurtCode.getGeometry();
				var extent = featureGeometry.getExtent();

				this.selectedBuurtExtent = extent;	
			},

			drawBuurten() {
				this.map.removeLayer(this.buurtLayer);

				let features = [];


				this.gemeenteSelected.buurten.forEach((buurt, buurtindex) => {
					let coords = [[]];

					buurt.buurt_polygon[0].forEach((coord) => {
						coords[0].push(fromLonLat(coord));
					});

					const feature = new Feature({
						geometry : new Polygon(coords)
					});
					feature.setProperties(buurt);

					features.push(feature);
				});

				let featureLayer = new VectorSource({
					features : features
				});

				this.buurtLayer = new VectorLayer({
					className: 'buurt-layer',
					source : featureLayer,
					style: this.styleFunction
				});

				this.gemeenteExtent = featureLayer.getExtent();

				this.map.addLayer(this.buurtLayer);
			},

			mapToLoc(extent) {
				this.view.fit(extent, { 
					padding: [50, 50, 50, 50],
					duration: 1000 
				});
			},

			mapToBuurt(buurt) {
				if(!this.buurtFeature) return;

				let feature = this.buurtFeature;

				var featureGeometry = feature.getGeometry();
				var extent = featureGeometry.getExtent();
				this.mapToLoc(extent);

			},

			highlightGemeente(gemeente) {
				this.mapToLoc(this.gemeenteExtent);
			}
		}
	}
</script>